import { Directionality } from "@angular/cdk/bidi";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Host, Input, Optional, Renderer2, TemplateRef } from "@angular/core";
import { NzBadgeComponent } from "ng-zorro-antd/badge";
import { NzConfigService, WithConfig } from "ng-zorro-antd/core/config";
import { NzNoAnimationDirective } from "ng-zorro-antd/core/no-animation";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { UiBadgeSize, UiBadgeStatusType } from "./badge.models";

@Component({
  selector: "ui-badge",
  exportAs: "uiBadge",
  templateUrl: "./badge.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiBadgeComponent extends NzBadgeComponent {
  @Input("uiShowZero") @InputBoolean() public nzShowZero = false;
  @Input("uiShowDot") @InputBoolean() public nzShowDot = true;
  @Input("uiStandalone") @InputBoolean() public nzStandalone = false;
  @Input("uiDot") @InputBoolean() public nzDot = false;
  @Input("uiOverflowCount") @WithConfig() public nzOverflowCount = 99;
  @Input("uiColor") @WithConfig() public nzColor?: string = undefined;
  @Input("uiSize") public size: UiBadgeSize;
  @Input("uiStyle") public nzStyle: { [key: string]: string } | null = null;
  @Input("uiText") public nzText?: string | TemplateRef<void> | null = null;
  @Input("uiTitle") public nzTitle?: string | null | undefined;
  @Input("uiStatus") public nzStatus?: UiBadgeStatusType | string;
  @Input("uiCount") public nzCount?: number | TemplateRef<NzSafeAny>;
  @Input("uiOffset") public nzOffset?: [number, number];

  constructor(
    nzConfigService: NzConfigService,
    renderer: Renderer2,
    cdr: ChangeDetectorRef,
    elementRef: ElementRef,
    @Optional() directionality: Directionality,
    @Host() @Optional() noAnimation?: NzNoAnimationDirective
  ) {
    super(nzConfigService, renderer, cdr, elementRef, directionality, noAnimation);
  }
}
